import { useEffect } from "react";

import { PreloadedQuery } from "react-relay";

import { pricingPageRelayQuery } from "@/__generated_contentful__/pricingPageRelayQuery.graphql";
import { PricingContentContextProviderRelay } from "@/components/wpl/pricing/src/pricing-content-context";
import { checkFeatureFlagGate, featureFlags } from "@/utils/feature-flags";
import { PricingContent } from "@/utils/pricing-queries/get-pricing-content";
import { UserLocale } from "@/utils/useGeoCurrency";

import { AppPricingData } from "../../../../contentful";
import { SoftwareGuardPricingPageTemplate } from "../../../../templates/software/guard/pricing/software-guard-pricing-page/src";

export type SoftwareGuardPricingPageProps = {
    pricing?: AppPricingData;
    countryCode?: UserLocale;
    pricingContent?: PricingContent;
    queryRef?: PreloadedQuery<pricingPageRelayQuery>;
};

export const SoftwareGuardPricingPageRelay = ({
    pricing,
    countryCode,
    pricingContent,
    queryRef
}: SoftwareGuardPricingPageProps) => {
    useEffect(() => {
        checkFeatureFlagGate(featureFlags.cpapiwdPricingAll);
    }, []);

    return (
        <PricingContentContextProviderRelay
            productId="atlassian-access"
            pricingContent={pricingContent}
            queryRef={queryRef}
        >
            <div data-testid="guard-pricing-page">
                <SoftwareGuardPricingPageTemplate
                    pricing={pricing}
                    countryCode={countryCode}
                />
            </div>
        </PricingContentContextProviderRelay>
    );
};
